import { render, staticRenderFns } from "./OverviewUsers.vue?vue&type=template&id=34eb0b8a"
import script from "./OverviewUsers.vue?vue&type=script&lang=ts"
export * from "./OverviewUsers.vue?vue&type=script&lang=ts"
import style0 from "./OverviewUsers.vue?vue&type=style&index=0&id=34eb0b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports